/*  @ 用于路由传参加密 */

const provinceJson = [{
    "id": 9,
    "dataKey": "110000",
    "dataValue": "北京",
    "dataDesc": "地域类型",
    "dataType": "DISTRICT_TYPE"
}, {
    "id": 10,
    "dataKey": "120000",
    "dataValue": "天津",
    "dataDesc": "地域类型",
    "dataType": "DISTRICT_TYPE"
}, {
    "id": 11,
    "dataKey": "130000",
    "dataValue": "河北省",
    "dataDesc": "地域类型",
    "dataType": "DISTRICT_TYPE"
}, {
    "id": 12,
    "dataKey": "140000",
    "dataValue": "山西省",
    "dataDesc": "地域类型",
    "dataType": "DISTRICT_TYPE"
}, {
    "id": 13,
    "dataKey": "150000",
    "dataValue": "内蒙古",
    "dataDesc": "地域类型",
    "dataType": "DISTRICT_TYPE"
}, {
    "id": 14,
    "dataKey": "210000",
    "dataValue": "辽宁省",
    "dataDesc": "地域类型",
    "dataType": "DISTRICT_TYPE"
}, {
    "id": 15,
    "dataKey": "220000",
    "dataValue": "吉林省",
    "dataDesc": "地域类型",
    "dataType": "DISTRICT_TYPE"
}, {
    "id": 16,
    "dataKey": "230000",
    "dataValue": "黑龙江",
    "dataDesc": "地域类型",
    "dataType": "DISTRICT_TYPE"
}, {
    "id": 17,
    "dataKey": "310000",
    "dataValue": "上海",
    "dataDesc": "地域类型",
    "dataType": "DISTRICT_TYPE"
}, {
    "id": 18,
    "dataKey": "320000",
    "dataValue": "江苏省",
    "dataDesc": "地域类型",
    "dataType": "DISTRICT_TYPE"
}, {
    "id": 19,
    "dataKey": "330000",
    "dataValue": "浙江省",
    "dataDesc": "地域类型",
    "dataType": "DISTRICT_TYPE"
}, {
    "id": 20,
    "dataKey": "340000",
    "dataValue": "安徽省",
    "dataDesc": "地域类型",
    "dataType": "DISTRICT_TYPE"
}, {
    "id": 21,
    "dataKey": "350000",
    "dataValue": "福建省",
    "dataDesc": "地域类型",
    "dataType": "DISTRICT_TYPE"
}, {
    "id": 22,
    "dataKey": "360000",
    "dataValue": "江西省",
    "dataDesc": "地域类型",
    "dataType": "DISTRICT_TYPE"
}, {
    "id": 23,
    "dataKey": "370000",
    "dataValue": "山东省",
    "dataDesc": "地域类型",
    "dataType": "DISTRICT_TYPE"
}, {
    "id": 24,
    "dataKey": "410000",
    "dataValue": "河南省",
    "dataDesc": "地域类型",
    "dataType": "DISTRICT_TYPE"
}, {
    "id": 25,
    "dataKey": "420000",
    "dataValue": "湖北省",
    "dataDesc": "地域类型",
    "dataType": "DISTRICT_TYPE"
}, {
    "id": 26,
    "dataKey": "430000",
    "dataValue": "湖南省",
    "dataDesc": "地域类型",
    "dataType": "DISTRICT_TYPE"
}, {
    "id": 27,
    "dataKey": "440000",
    "dataValue": "广东省",
    "dataDesc": "地域类型",
    "dataType": "DISTRICT_TYPE"
}, {
    "id": 28,
    "dataKey": "450000",
    "dataValue": "广西",
    "dataDesc": "地域类型",
    "dataType": "DISTRICT_TYPE"
}, {
    "id": 29,
    "dataKey": "460000",
    "dataValue": "海南省",
    "dataDesc": "地域类型",
    "dataType": "DISTRICT_TYPE"
}, {
    "id": 30,
    "dataKey": "500000",
    "dataValue": "重庆",
    "dataDesc": "地域类型",
    "dataType": "DISTRICT_TYPE"
}, {
    "id": 31,
    "dataKey": "510000",
    "dataValue": "四川省",
    "dataDesc": "地域类型",
    "dataType": "DISTRICT_TYPE"
}, {
    "id": 32,
    "dataKey": "520000",
    "dataValue": "贵州省",
    "dataDesc": "地域类型",
    "dataType": "DISTRICT_TYPE"
}, {
    "id": 33,
    "dataKey": "530000",
    "dataValue": "云南省",
    "dataDesc": "地域类型",
    "dataType": "DISTRICT_TYPE"
}, {
    "id": 34,
    "dataKey": "540000",
    "dataValue": "西藏",
    "dataDesc": "地域类型",
    "dataType": "DISTRICT_TYPE"
}, {
    "id": 35,
    "dataKey": "610000",
    "dataValue": "陕西省",
    "dataDesc": "地域类型",
    "dataType": "DISTRICT_TYPE"
}, {
    "id": 36,
    "dataKey": "620000",
    "dataValue": "甘肃省",
    "dataDesc": "地域类型",
    "dataType": "DISTRICT_TYPE"
}, {
    "id": 37,
    "dataKey": "630000",
    "dataValue": "青海省",
    "dataDesc": "地域类型",
    "dataType": "DISTRICT_TYPE"
}, {
    "id": 38,
    "dataKey": "640000",
    "dataValue": "宁夏",
    "dataDesc": "地域类型",
    "dataType": "DISTRICT_TYPE"
}, {
    "id": 39,
    "dataKey": "650000",
    "dataValue": "新疆",
    "dataDesc": "地域类型",
    "dataType": "DISTRICT_TYPE"
}, {
    "id": 40,
    "dataKey": "710000",
    "dataValue": "台湾省",
    "dataDesc": "地域类型",
    "dataType": "DISTRICT_TYPE"
}, {
    "id": 41,
    "dataKey": "810000",
    "dataValue": "香港",
    "dataDesc": "地域类型",
    "dataType": "DISTRICT_TYPE"
}, {
    "id": 42,
    "dataKey": "820000",
    "dataValue": "澳门",
    "dataDesc": "地域类型",
    "dataType": "DISTRICT_TYPE"
}]
 export default provinceJson